import type { Footnotes as FootnotesType } from 'types/cms/Footnotes';

import { BlogSectionHeading } from '../BlogSectionHeading';
import { FootnotesList } from './FootnotesList';

interface FootnotesProps {
  footnotes: FootnotesType[];
}

export function Footnotes({ footnotes }: FootnotesProps) {
  return (
    <>
      <BlogSectionHeading id="references">References</BlogSectionHeading>
      <FootnotesList footnotes={footnotes} />
    </>
  );
}
